import {
    getClosestConfigurationFromSeat,
    getClosestConfigurationFromGeneralAdmission,
} from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getClosestConfiguration';
import {
    OBJECT_TYPE_GENERAL_ADMISSION,
    OBJECT_TYPE_SEAT,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import { TEXT_COLOR, GENERAL_ADMISSION_FILL } from '%paysera_seat_selection/js/seatSelection/config/defaults';

export default ({ Seat, GeneralAdmission }, { payload }) => {
    const { models } = payload;

    models.forEach(({ id, objectType, ticketType }) => {
        if (ticketType === null) {
            return;
        }

        let objectFill = null;
        let object = null;

        if (objectType === OBJECT_TYPE_SEAT) {
            object = Seat.withId(id);
            if (object.ticketType) {
                object.ticketType.seats.remove(object);

                const { seatConfig: { selected: { fill } } } = getClosestConfigurationFromSeat(
                    object,
                    'seatConfig',
                );

                objectFill = fill;
            }
        }

        if (objectType === OBJECT_TYPE_GENERAL_ADMISSION) {
            object = GeneralAdmission.withId(id);
            objectFill = GENERAL_ADMISSION_FILL;

            if (object.ticketType) {
                object.ticketType.generalAdmissions.remove(object);

                const { generalAdmissionConfig: { fill } } = getClosestConfigurationFromGeneralAdmission(
                    object,
                    'generalAdmissionConfig',
                );

                objectFill = fill;
            }
        }

        if (object === null) {
            throw Error(`Unrecognized object type "${objectType}" in handleUnassignTicketTypeFromModel`);
        }

        object.update({
            ticketType: null,
            compiled: {
                ...object.compiled,
                fill: objectFill,
            },
            label: {
                ...object.label,
                compiled: {
                    ...object.label.compiled,
                    color: TEXT_COLOR,
                },
            },
        });
    });
};
